import { get } from 'lodash';

export const createArray = (arr, path) => {
  // array according to the specified path
  const dd = get(arr, path, []);
  // return array [id: value, name: value]
  // +1 because the input array starts from 0
  return dd.map((item, index)=>({ id: index + 1, name: item }));
};
